export default __webpack_public_path__ + "static/media/refrel.4edd3d7b.svg";